import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";
import { ArquivoScr } from './arquivo-src.model';
import { OperacaoScr } from './operacao-scr.model';

export class ValidacaoScr extends BaseEntity {

	  public dataValidacao:string;
    public tipoValidacao:string;
    public qtdeSolicitacoesHonraValidadasComSucesso: string;
    public qtdeSolicitacoesHonraValidadasComErro: string;
}

export class SolicitacaoHonraValidacaoScr extends BaseEntity {

	public idSolicitacaoHonra: number;
	public cnpjAgenteFinanceiro: string;
	public nomeJanela: string;
	public idOperacaoAgenteCreditoLivre: string;
	public sistemaRepasse: string;
	public contratoRepasse: string;
	public possuiErrosDeValidacao: boolean;
}

export class SolicitacaoHonraValidacaoArquivoScr extends BaseEntity {
    public arquivoScrUtilizadoNaValidacao:ArquivoScr;
	public operacaoScrUtilizadaNaValidacao:OperacaoScr;
	public trocaIpoc:boolean;
    public ipocNovo:string;
}

export const TIPOS_VALIDACAO_ARQ_SCR = [
	{
	codigo: 'E',
	label: 'Envio solicitação'
	},
	{
	  codigo: 'P',
	  label: 'Processamento'
	},
	{
	   codigo: 'R',
	   label: 'Reprocessamento de SHs'
	},
	{
		codigo: 'C',
		label: 'Consistência de mês posterior'
	},
	{
		codigo: 'I',
		label: 'Indícios de Recuperação de Crédito'
	},
	{
		codigo: 'N',
		label: 'Reprocessamento de Indícios de Recuperação'
	},
	{
		codigo: 'M',
		label: 'Reprocessamento de consistência'
	}
  ];

  export const STATUS_VALIDACAO = [
	  {
		label: 'Todos'
	  },
	  {
		label: 'Sucesso'
	  },
	  {
		label: 'Erro'
	  }
  ]
